// Before/after comparisons (case-study section type "compare").
//
// Without JS each figure shows both screenshots, one above the other. This
// stacks them in a single frame, shows "before" first, and reveals the toggle so
// "after" swaps in exactly over it, which makes the differences easy to spot.
(function () {
	document.querySelectorAll('.cs-compare .compare').forEach(figure => {
		const toggle = figure.querySelector('.compare-toggle');
		const buttons = toggle.querySelectorAll('button');

		const show = version => {
			figure.classList.toggle('show-after', version === 'after');
			buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.show === version)));
		};

		buttons.forEach(button => button.addEventListener('click', () => show(button.dataset.show)));
		figure.classList.add('is-stacked');
		toggle.hidden = false;
		show('before');
	});
})();
